import { EntityState, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice";
import { HomeRecent } from "../types/types";

const homeRecentAdaptor = createEntityAdapter<HomeRecent>({
  selectId: (recent) => recent._id
})

type HomeRecentInitialState = EntityState<HomeRecent>

const initialState: HomeRecentInitialState =
  homeRecentAdaptor.getInitialState()

export const extendedHomeRecentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllRecent: builder.query<EntityState<HomeRecent>, void>({
      query: () => '/recent-home',
      transformResponse: (response: HomeRecent[]) => {
        return homeRecentAdaptor.setAll(initialState, response)
      },
      providesTags: ["Recent"]
    }),
    addRecent: builder.mutation<EntityState<HomeRecent>, Partial<HomeRecent>>({
      query: (recent) => ({
        url: '/recent-home',
        method: 'PUT',
        body: recent
      }),
      transformResponse: (response: HomeRecent) => {
        return homeRecentAdaptor.updateOne(initialState, {
          id: response._id,
          changes: response
        })
      },
      invalidatesTags: ["Recent"]
    }),
  }),
});

export const { useGetAllRecentQuery, useAddRecentMutation } =
  extendedHomeRecentApi
